import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import BillsOfMaterialsPage from "../pages/BillsOfMaterials";
import CreateBillOfMaterialsPage from "../pages/BillsOfMaterials/create";
import ProductionOrdersPage from "../pages/ProductionOrders";
import CreateProductionOrderPage from "../pages/ProductionOrders/create";
import ViewProductionOrderPage from "../pages/ProductionOrders/view";

export default function ProductionRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="production.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route element={<PermissionRoute permission="production.boms.view" />}>
        <Route path="bills-of-materials">
          <Route path="" element={<BillsOfMaterialsPage />} />
          <Route path="create" element={<CreateBillOfMaterialsPage />} />
          <Route path="edit/:id" element={<CreateBillOfMaterialsPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="production.orders.view" />}>
        <Route path="orders">
          <Route path="" element={<ProductionOrdersPage />} />
          <Route path="create" element={<CreateProductionOrderPage />} />
          <Route path="edit/:id" element={<CreateProductionOrderPage />} />
          <Route path="view/:id" element={<ViewProductionOrderPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
